import { render, staticRenderFns } from "./addFeeConfig.vue?vue&type=template&id=13e9b176&scoped=true"
import script from "./addFeeConfig.vue?vue&type=script&lang=js"
export * from "./addFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./addFeeConfig.vue?vue&type=style&index=0&id=13e9b176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e9b176",
  null
  
)

export default component.exports